/**
 * Creates the callback on the user data to assign the member data
 * 
 * @param {Object} user 
 * @param {Object} member 
 */
export function createUserCallback(user, member){
    /**
     * Override the callback for the user API as it also returns the member
     * Assign the member to the member data store
     * 
     * @param {Object} data The api response
     * @returns {Object}
     */
    user.api.callbacks.add(
        'onSuccess',
        (data, original) => {
            member.details.value = original.member ?? {}
        }
    )
}